import { render, staticRenderFns } from "./assign-course-modal.vue?vue&type=template&id=43acd5f5&scoped=true&"
import script from "./assign-course-modal.vue?vue&type=script&lang=js&"
export * from "./assign-course-modal.vue?vue&type=script&lang=js&"
import style0 from "./assign-course-modal.vue?vue&type=style&index=0&id=43acd5f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acd5f5",
  null
  
)

export default component.exports